export default __webpack_public_path__ + "static/clay-banks-xv-s-u-k-uo-uao-unsplash-ddcb1bbeeb481a7d7d4f95b7728fd7ef.png";